/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Recipient identifier for notification resolution
 * @export
 * @interface NotificationRecipient
 */
export interface NotificationRecipient {
    /**
     * User ID (resolves to email, phone, etc. from profile)
     * @type {string}
     * @memberof NotificationRecipient
     */
    userId?: string;
    /**
     * Email address (used when userId not provided or as fallback)
     * @type {string}
     * @memberof NotificationRecipient
     */
    email?: string;
    /**
     * E.164 phone number (used when userId not provided or as fallback)
     * @type {string}
     * @memberof NotificationRecipient
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the NotificationRecipient interface.
 */
export function instanceOfNotificationRecipient(value: object): value is NotificationRecipient {
    return true;
}

export function NotificationRecipientFromJSON(json: any): NotificationRecipient {
    return NotificationRecipientFromJSONTyped(json, false);
}

export function NotificationRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationRecipient {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}

export function NotificationRecipientToJSON(json: any): NotificationRecipient {
    return NotificationRecipientToJSONTyped(json, false);
}

export function NotificationRecipientToJSONTyped(value?: NotificationRecipient | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
    };
}

